import {getNewPortalBaseUrl} from './get-new-portal-base-url'

export type NewPortalAuthPath = '/login' | '/forgot-password' | '/define-password'

export function buildNewPortalAuthUrl(path: NewPortalAuthPath): string | null {
  const base = getNewPortalBaseUrl()
  if (!base) return null

  const url = new URL(path, `${base}/`)

  if (path === '/login') {
    return url.toString()
  }

  if (typeof window !== 'undefined') {
    const current = new URLSearchParams(window.location.search)
    current.forEach((value, key) => {
      if (!url.searchParams.has(key)) url.searchParams.set(key, value)
    })
  }

  return url.toString()
}

export function redirectToNewPortalAuth(path: NewPortalAuthPath = '/login'): boolean {
  const target = buildNewPortalAuthUrl(path)
  if (!target) return false

  window.location.replace(target)
  return true
}
